import { apiFetch } from "@/hooks/apiFetch"
type OrderItem = {
  id: number
  name: string
  sell_price: number
  quantity: number
  sku: string
  stock: number
  discountedPrice: number
  total: number
}

type OrderData = {
  customer_id: number
  date: string
  payment_method: number
  order_items: OrderItem[]
  subtotal: number
  change: number
  cash_received: number
  split_billing: boolean
  split_payments: { id: number; amount: number }[]
  discount_percent: number
  discount_amount: number
  total_discount_amount: number
  total_amount: number
}

export const orderService = {
  createOrder: async (orderData: OrderData) =>
    apiFetch("order", {
      method: "POST",
      body: JSON.stringify(orderData),
    }),
  updateOrder: async (orderId: number, orderData: OrderData) =>
    apiFetch(`order/${orderId}`, {
      method: "PUT",
      body: JSON.stringify(orderData),
    }),
}
